import { CURRENT_BROKER_NAME } from "@/config/logos";
import { useEffect, useRef } from "react";

interface CanvasScriptLoaderProps {
  config: any;
}

interface StrategyConfig {
  token: string;
  user_id: string;
  user_name: string;
  symbol: string;
  strategy_id: string;
  unique_key: string;
  timeframe: string;
  strategy_name: string;
  strategy_data: any;
  strategy_fullname: string;
  show_nudges_tutorial_flow: boolean | string;
  back_button_url: string;
  logoVisible: boolean;
  broker_name: string;
  broker_logo: string;
}

// 2. Extend the Window interface
declare global {
  interface Window {
    __STRATEGY_CONFIG__?: Partial<StrategyConfig>;
  }
}

const CanvasScriptLoader = ({ config }: CanvasScriptLoaderProps) => {
  const scriptInjectedRef = useRef(false);
  useEffect(() => {
    if (!config || scriptInjectedRef.current) return;

    window.__STRATEGY_CONFIG__ = {
      ...config,
      broker_name: CURRENT_BROKER_NAME,
      logoVisible: false,
    };

    const timeout = setTimeout(() => {
      const script = document.createElement("script");
      const scriptUrl = `/canvas/edit/new/level2-index.js?v=${Date.now()}`;

      script.src = scriptUrl;
      script.type = "module";
      script.id = "strategy_bundle";
      document.body.appendChild(script);
      scriptInjectedRef.current = true;
    }, 100);

    return () => clearTimeout(timeout);
  }, [config]);

  return null;
};

export default CanvasScriptLoader;
